import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { CalendarClock, Check, RefreshCw } from "lucide-react";
import { Card, CardHead, Btn } from "@/components/ui-kit";
import api from "@/lib/api";

const fmt = (d) => new Date(`${d}T00:00:00`).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });

function Row({ a, onResolve, onOpen }) {
  const expired = a.days_left < 0;
  return (
    <div className={`flex items-center gap-2.5 flex-wrap rounded-lg px-3 py-2 text-[12.5px] ${expired ? "bg-rose-50 border border-rose-100" : "bg-amber-50/60 border border-amber-100"}`} data-testid={`ops-expiry-${a.id}`}>
      <button onClick={() => onOpen(a.clinician_id)} className="font-semibold text-[#1A3A6D] hover:underline" data-testid={`ops-expiry-open-${a.id}`}>{a.clinician_name}</button>
      <span className="text-slate-700">{a.label}</span>
      <span className={`font-semibold ${expired ? "text-rose-700" : "text-amber-800"}`} data-testid={`ops-expiry-days-${a.id}`}>
        {expired ? `Expired ${fmt(a.expiry)}` : `Expires ${fmt(a.expiry)} · ${a.days_left} day${a.days_left === 1 ? "" : "s"}`}
      </span>
      <button onClick={() => onResolve(a)} className="ml-auto inline-flex items-center gap-1 text-[11.5px] font-semibold text-slate-500 hover:text-teal-700" data-testid={`ops-expiry-resolve-${a.id}`}><Check size={12} /> Mark handled</button>
    </div>
  );
}

export default function ExpiryAlerts({ onOpen }) {
  const [list, setList] = useState(null);
  const load = useCallback(() => api.get("/ops/credential-alerts").then((r) => setList(r.data)).catch(() => setList([])), []);
  useEffect(() => { load(); }, [load]);
  const refresh = async () => { await api.post("/ops/credential-alerts/refresh"); load(); toast.success("Expiry check refreshed"); };
  const resolve = async (a) => { await api.put(`/ops/credential-alerts/${a.id}/resolve`); load(); };
  return (
    <Card className="mt-4" data-testid="ops-expiry-alerts">
      <CardHead title={<span className="inline-flex items-center gap-2"><CalendarClock size={16} className="text-amber-600" /> Documents expiring within 30 days</span>}
        action={<Btn size="sm" onClick={refresh} data-testid="ops-expiry-refresh"><RefreshCw size={13} /> Check now</Btn>} />
      <div className="px-5 py-4">
        {list === null ? null : list.length === 0
          ? <p className="text-[12.5px] text-slate-400" data-testid="ops-expiry-empty">No clinician documents expiring in the next 30 days.</p>
          : <div className="space-y-1.5">{list.map((a) => <Row key={a.id} a={a} onResolve={resolve} onOpen={onOpen} />)}</div>}
      </div>
    </Card>
  );
}
